module.exports = "<bulk-invoice-item-types-uploads-page></bulk-invoice-item-types-uploads-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/bulkInvoiceItemTypesUploadsView.html
// module id = 2213
// module chunks = 0